import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space16,
    padding: theme.spacing.space16,
    alignItems: "flex-start",
  },
}));
